// What year is this??
import $ from 'jquery'
import 'slick-carousel'

$(document).ready(() => {
  const slickBaseOpts = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
  }

  $('.homepage-redux .hero-redux__carousel .carousel').each(function() {
    $(this).slick({
      ...slickBaseOpts,
      arrows: true,
      prevArrow: $(this).siblings('.carousel__control.carousel__control--prev'),
      nextArrow: $(this).siblings('.carousel__control.carousel__control--next'),
    });
  });
})
